import { useTranslation } from "react-i18next";
import {
    GetSupplierIndicatorsDocument,
    Indicator,
} from "../../../../generated/client/graphql";
import { useGraphQL } from "../../../QueryClientWithHeaders";
import ButtonRegular from "../../../components/Button/ButtonRegular";
import Container from "../../../components/Container";
import SearchFilter, {
    searchFilterStringAtom,
} from "../../../components/Filters/Search";
import BodyHeader from "../../../shared/components/BodyHeader";

import { useAtom } from "jotai";
import SupplierIndicatorTable from "../../../components/IndicatorTable";
import "./i18n";

export default function Questionnaires() {
    const { t } = useTranslation("SupplierQuestionnaires");
    const { data, isLoading, refetch } = useGraphQL(
        GetSupplierIndicatorsDocument,
        undefined,
    );
    const [searchString, setSearchString] = useAtom(searchFilterStringAtom);
    return (
        <Container>
            <BodyHeader
                title={t("title")}
                subTitle={t("subtitle")}
                action={
                    <>
                        <ButtonRegular
                            text={t("create_indicator_button")}
                            onClick={() => {}}
                            disabled={true}
                        />
                    </>
                }
            />
            <div className="p-4 space-y-4">
                <SearchFilter
                    searchString={searchString}
                    setSearchString={setSearchString}
                />
                <SupplierIndicatorTable
                    indicators={
                        data?.indicators?.sort(
                            (i1, i2) => i1.order - i2.order,
                        ) as Indicator[]
                    }
                    isLoading={isLoading}
                    refetch={refetch}
                />
            </div>
        </Container>
    );
}
